var avatarReset = '_1fw4p2i0';
var imageOverlay = '_1fw4p2i2 _1fw4p2i1';
var initial = '_1fw4p2i3';

export { avatarReset, imageOverlay, initial };
//# sourceMappingURL=avatar-reset.css.js.map
